export const LEGAL_CONFIRMATION_LOGIN_PARAMS = {
  legal_confirmation_client: 'supplier_pc_v1',
  legal_confirmed: 1,
};
